import { render, staticRenderFns } from "./backoffice-equipe-cirurgia-conjunta.vue?vue&type=template&id=72974d82"
import script from "./backoffice-equipe-cirurgia-conjunta.vue?vue&type=script&lang=ts"
export * from "./backoffice-equipe-cirurgia-conjunta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports